import { render, staticRenderFns } from "./informationGeneral.vue?vue&type=template&id=28deb972&scoped=true&"
import script from "./informationGeneral.vue?vue&type=script&lang=js&"
export * from "./informationGeneral.vue?vue&type=script&lang=js&"
import style0 from "./informationGeneral.vue?vue&type=style&index=0&id=28deb972&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28deb972",
  null
  
)

export default component.exports